var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-more",on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',[_vm._v(_vm._s(_vm.show ? _vm.$t('showLess') : _vm.$t('showAll')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }